import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-work-devex-home",
  templateUrl: "./work-devex-home.component.html",
  styleUrls: ["./work-devex-home.component.scss"],
})
export class WorkDevexHomeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/work-devex-home/work-devex-home.component.ts